<template>
    <footer class="footer-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 text-center">
                    <img src="@/assets/footer_logo.png" class="logo" alt="獅王logo">
                    <p class="copyright-text mb-hide">獅王家品股份有限公司 版權所有 轉載必究 LION.TW Inc.</p>
                </div>
                <div class="col-lg-6">
                    <p class="link-text">
                        <a href="" @click.prevent="openNewWindow('http://bit.ly/2FyF7qW', 'LION_EC')">日本獅王官方旗艦館</a>  |
                        <a href="" @click.prevent="openNewWindow('https://www.facebook.com/lifelovelion/', 'LION_FB')">Facebook</a>  |
                        <a href="" @click.prevent="openNewWindow('https://www.youtube.com/channel/UCNsmNXVUQsUOgoLcSqsd1Yw/featured', 'LION_YT')">Youtube</a>  |
                        <a href="" @click.prevent="openNewWindow('https://www.instagram.com/lion_tw/', 'LION_IG')">Instagram</a>
                    </p>
                    <p class="copyright-text pc-hide">獅王家品股份有限公司 版權所有 轉載必究 LION.TW Inc.</p>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    methods: {
        openNewWindow(url, label) {
            this.gaEvent('footer_btn', label);
            window.open(url, 'blank');
        },
    },
    mixins: [mixinMethod],
};

</script>
